module.exports = __webpack_public_path__ + "img/LoginFormRightSide.b5dd4d29.png";